import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateEventStage($companyId: ID!, $attributes: EventStageAttributes!) {
    createEventStage(companyId: $companyId, attributes: $attributes) {
      eventStage {
        id
        ...CreatedEventStage
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedEventStage on EventStage {
    id
    name
    notes
  }
`
